<template>
  <div class="mackCon pf pr proTree" v-if="visible">
    <div class="inMaskCon pa center">
      <h3 class="title tal">【{{ curData.pcName }}】进程树<i class="closeIncon f30 pa cp" @click="visible = false">×</i></h3>
      <div class="contentCon">
        <div class="btnCon tal clearfix">
          <Button size="small" type="primary" @click="reshFn">刷新</Button>
          <div class="fr">
            <Input v-model="searchVal" clearable placeholder="请输入..." style="width: 210px">
            <Button slot="append" icon="ios-search" @click="searchFn"></Button>
            </Input>
          </div>
        </div>
        <!-- <Table stripe border :loading="loading" row-key="id" :columns="columns" :data="newData">
          <template slot="action" slot-scope="{row}">
            <Button @click="rowClick(row)" size="small" type="info">详情</Button>
          </template>
        </Table> -->
        <table border="0" style="width:1318px">
          <tr>
            <th class="tac" style="width:20%;">进程路径</th>
            <th class="tac" style="width:5%;">进程ID</th>
            <th class="tac" style="width:5%;">父进程ID</th>
            <th class="tac" style="width:10%;">公司名称</th>
            <th class="tac" style="width:10%;">文件说明</th>
            <th class="tac" style="width:10%;">文件版本</th>
            <th class="tac" style="width:10%;">数字签名公司名</th>
            <th class="tac" style="width:10%;">创建时间</th>
            <th class="tac" style="width:10%;">结束时间</th>
            <th class="tac">操作</th>
          </tr>
        </table>
        <div class="itemContainer" ref="itemContainer">
          <no-data style="height:auto;padding-top:20px;padding-bottom:20px;" v-show="newData.length == 0 || loading"
            :nodata="newData.length == 0 && !loading" :loading="loading"></no-data>
          <virtual-list :data-sources="newData" :extra-props="{ rowClick: rowClick, expend: expend }" :data-key="'id'"
            :data-component="itemCom">
          </virtual-list>
        </div>
        <div class="listContainer" ref="listContainer">
          <logListCom />
        </div>
      </div>
    </div>
    <div class="detailCon pa center" v-if="isShowDetail">
      <h3 class="title tal f14 fw">进程详情<i class="closeIncon f30 pa cp" @click="isShowDetail = false">×</i></h3>
      <div class="inDetailCon">
        <div class="itemCon clearfix">
          <div class="fl">进程属性</div>
          <div class="fl">信息</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">进程名</div>
          <div class="fl ells1">{{ detailInfo.exeName }}</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">进程ID</div>
          <div class="fl ells1">{{ detailInfo.pid }}</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">创建时间</div>
          <div class="fl ells1">{{ detailInfo.createTime }}</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">结束时间</div>
          <div class="fl ells1">{{ detailInfo.endTime }}</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">进程状态</div>
          <div class="fl ells1" v-text="detailInfo.status == 1 ? '运行中' : '已结束'"></div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">进程路径</div>
          <div class="fl ells1" :title="detailInfo.fullPath">{{ detailInfo.fullPath }}</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">进程命令行</div>
          <div class="fl ells1">{{ detailInfo.cmdLine }}</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">公司名称</div>
          <div class="fl ells1">{{ detailInfo.fileProductName }}</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">进程MD5</div>
          <div class="fl ells1">{{ detailInfo.md5 }}</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">进程特征码</div>
          <div class="fl ells1">{{ detailInfo.hash }}</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">数字签名公司名
          </div>
          <div class="fl ells1">{{ detailInfo.signName }}</div>
        </div>
        <div class="itemCon clearfix">
          <div class="fl">数字签名序列号
          </div>
          <div class="fl ells1">{{ detailInfo.signCode }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueEasyTree from '@wchbrad/vue-easy-tree';
// 样式文件，可以根据需要自定义样式或主题
import '@wchbrad/vue-easy-tree/src/assets/index.scss'
import NoData from '_c/noData/noData';
import { getProTree, getProDetail } from '@/requests/proTree.js'
import VirtualList from 'vue-virtual-scroll-list';
import ItemComponents from './item.vue'
import logListCom from './logList.vue'
export default {
  props: ['curData'],
  components: {
    'virtual-list': VirtualList,
    NoData,
    logListCom
  },
  data () {
    return {
      visible: false,
      loading: false,
      columns: [
        {
          title: '进程路径',
          key: 'fullPath',
          align: 'center',
          tooltip: true,
          width: 400,
          tree: true,
        },
        {
          title: '公司名称',
          key: 'signName',
          align: 'center',
          tooltip: true,
          resizable: true,
        },
        {
          title: '进程ID',
          key: 'pid',
          align: 'center',
          tooltip: true,
          resizable: true,
        },
        {
          title: '父进程ID',
          key: 'parentPid',
          align: 'center',
          tooltip: true,
          resizable: true,
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          resizable: true,
        },
        {
          title: '操作',
          slot: 'action',
          width: 100,
        },
      ],
      data: [
        {
          name: '122',
          id: 100,
          children: [
            {
              id: 10000,
              name: '2223',
              children: [
                {
                  name: '2223',
                },
              ],
            },
          ],
        },
        {
          name: '122',
          id: 100,
          children: [
            {
              id: 10000,
              name: '2223',
              children: [
                {
                  name: '2223',
                },
              ],
            },
          ],
        },
      ],
      searchVal: '',
      newData: [],
      detailData: '',
      detailInfo: {},
      isShowDetail: false,
      itemCom: ItemComponents

    }
  },
  watch: {
    visible () {
      if (this.visible) {
        this.getProTree()
      }
    },
    // searchVal () {
    //   this.getNewData()
    // }
  },
  mounted () {
    this.getNewData()
  },
  methods: {
    searchFn () {
      this.getNewData()
    },
    expend (index, key, key1, key2, key3, key4) {
      console.log(index, key, key1, key2, key3, key4)
      if (key4 != undefined) {
        this.newData[index].children[key].children[key1].children[key2].children[key3].children[key4].expend = !this.newData[index].children[key].children[key1].children[key2].children[key3].children[key4].expend
      } else if (key3 != undefined) {
        this.newData[index].children[key].children[key1].children[key2].children[key3].expend = !this.newData[index].children[key].children[key1].children[key2].children[key3].expend
      } else if (key2 != undefined) {
        this.newData[index].children[key].children[key1].children[key2].expend = !this.newData[index].children[key].children[key1].children[key2].expend
      } else if (key1 != undefined) {
        console.log(this.newData[index].children[key].children[key1].expend)
        this.newData[index].children[key].children[key1].expend = !this.newData[index].children[key].children[key1].expend
      } else if (key != undefined) {
        this.newData[index].children[key].expend = !this.newData[index].children[key].expend
      } else {
        this.newData[index].expend = !this.newData[index].expend
      }
    },
    rowClick (row) {
      this.detailData = row
      this.isShowDetail = true
      this.getProDetail()
    },
    async getProDetail () {
      console.log(this.detailData)
      let res = await getProDetail({
        id: this.curData.id,
        pid: this.detailData.id
      })
      if (res.code == 200) {
        this.detailInfo = res.data
      }
    },
    getNewData () {
      this.loading = true
      this.newData = []
      setTimeout(() => {
        if (this.data != '') {
          this.newData = [...this.getIndex(this.data)]
        } else {
          this.loading = false
        }
      }, 1000);
    },
    getIndex (arr) {
      let newArr = [...arr]
      newArr.forEach((element) => {
        element.isHaf = false
        if (element.fullPath.indexOf(this.searchVal) != -1 && this.searchVal != '') {
          element.isHaf = true
        } else {
          element.isHaf = false
          if (element.children && element.children.length > 0) {
            this.getIndex(element.children)
          }
        }
      });
      newArr = this.isExpend(newArr)
      return newArr
    },
    isExpend (arr) {
      arr.forEach(element => {
        if (element.isHaf) {
          element.expend = true
        } else {
          if (element.children && element.children.length > 0) {
            if (this.childrenExpen(element.children)) {
              element.expend = this.childrenExpen(element.children)
            }
          }
        }
      })
      return arr
    },
    childrenExpen (arr) {
      let isFalse = false
      arr.forEach(element => {
        if (element.isHaf) {
          isFalse = true
        } else {
          if (element.children && element.children.length > 0) {
            this.childrenExpen(element.children)
          }
        }
      });
      this.loading = false
      return isFalse
    },
    reshFn () {
      this.searchVal = ''
      this.getProTree()
    },
    async getProTree () {
      this.loading = true
      let res = await getProTree({
        id: this.curData.id
      })
      this.loading = false
      if (res.code == 200) {
        console.log(res.data)
        console.log(121)
        this.data = res.data
        console.log(this.data)
        console.log(123)
        this.getNewData()
      }
    },

  },
}
</script>
<style lang="scss" scoped>
.inMaskCon {
  width: 1358px;
  height: 90%;
  margin-top: 30px;
  padding: 0 10px;
  box-sizing: border-box;

  .contentCon {
    padding: 10px;
    height: 90%;
    overflow: hidden;
    box-sizing: border-box;

    table {
      th {
        background: #f8f8f9;
      }

      tr,
      th,
      td {
        line-height: 30px;
        border-color: #e8eaec;
      }
    }
  }

  .btnCon {
    margin: 10px 0;
  }

}

.itemContainer {
  height: calc(100% - 384px);
  overflow-y: auto;
}

.listContainer {
  height: 340px;
}
</style>
<style lang="scss">
.proTree {
  .ivu-table-cell-tooltip {
    display: inline-block;
    width: auto;
  }

  .ivu-table-cell-tree-level {
    display: none;
  }

  .ivu-tooltip .ivu-tooltip-rel {
    vertical-align: bottom;
    width: 360px !important;
    text-align: left;
    text-indent: 4px;
  }
}
</style>